import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../sagas/root";

export default function HtmlTestPage({ date, ms_id }) {
  const [htmlPage, setHtmlPage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!date || !ms_id) return;

    async function fetchHTML() {
      try {
        setLoading(true);
        const response = await axios.get(
          `${baseURL}/widget/broadcast`,
          { params: { date, ms_id } }
        );
        setHtmlPage(response.data);
      } catch (error) {
        console.error("Ошибка загрузки HTML:", error);
        setHtmlPage("<p style='color:red'>Не удалось загрузить HTML</p>");
      } finally {
        setLoading(false);
      }
    }

    fetchHTML();
  }, [date, ms_id]);

  return (
    <div id="html-container" style={{ position: "relative" }}>
      {loading && (
        <div className="loader-overlay">
          <div className="spinner" />
          <p style={{ marginLeft: 8 }}>Загрузка...</p>
        </div>
      )}

      <div dangerouslySetInnerHTML={{ __html: htmlPage }} />

      <style jsx>{`
        .loader-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.7);
          z-index: 999;
        }

        .spinner {
          width: 20px;
          height: 20px;
          border: 2px solid #ccc;
          border-top-color: #333;
          border-radius: 50%;
          animation: spin 0.7s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}
